import * as CONST from "./actionTypes";

const intialState = {
  loading: false,
  error: null,
};

const DeleteSubscriberReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.DELETE_FACEBOOK:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_FACEBOOK_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_FACEBOOK_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETEALL_FACEBOOK:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_FACEBOOK_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_FACEBOOK_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETE_INSTAGRAM:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_INSTAGRAM_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_INSTAGRAM_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETEALL_INSTAGRAM:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_INSTAGRAM_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_INSTAGRAM_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETE_TWITTER:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_TWITTER_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_TWITTER_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETEALL_TWITTER:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_TWITTER_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_TWITTER_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETE_YOUTUBE:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_YOUTUBE_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_YOUTUBE_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETEALL_YOUTUBE:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_YOUTUBE_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_YOUTUBE_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETE_TIKTOK:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_TIKTOK_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_TIKTOK_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETEALL_TIKTOK:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_TIKTOK_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_TIKTOK_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETE_CONTACT:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_CONTACT_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_CONTACT_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETEALL_CONTACT:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_CONTACT_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_CONTACT_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETE_SUBSCRIBER:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_SUBSCRIBER_FAIL:
      return {
        ...state,
        error: payload,
      };

    case CONST.DELETEALL_SUBSCRIBER:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_SUBSCRIBER_SUCCESS:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETEALL_SUBSCRIBER_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default DeleteSubscriberReducer;
